<template>
  <div class="header-menu">
    <img class="img-principal" src="../assets/img/EL_COMPADRE.png" alt="">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <button class="navbar-toggler position-relative" style="left: 80%;" type="button" data-toggle="collapse"
        data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse menu-movil" id="navbarText">
        <ul class="navbar-nav mx-auto">
          <li class="nav-item active">
            <router-link to="/" class="nav-link">Menú</router-link>
          </li>

          <li class="nav-item">
            <router-link to="/ordenar" class="nav-link">Ordenar</router-link>
          </li>

          <li class="nav-item">
            <router-link to="/acerca" class="nav-link">Acerca de</router-link>
          </li>

          <li class="nav-item nav-item-contacto">
            <a href="tel:9831451917" class="btn-contacto btn-llamar">
              <i class="bi bi-telephone-fill"></i>
              <span>983 145 1917</span>
            </a>
          </li>

          <li class="nav-item nav-item-contacto">
            <a href="https://www.facebook.com/carnitaselcompadre" target="_blank" rel="noopener noreferrer" class="btn-contacto btn-facebook">
              <i class="bi bi-facebook"></i>
              <span>Facebook</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'HeaderMenu',
  props: {
  }
}
</script>

<style scoped>
.nav-item-contacto {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.25rem;
}

.btn-contacto {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.2s;
}

.btn-contacto:hover {
  opacity: 0.85;
  text-decoration: none;
}

.btn-llamar {
  background-color: #2c7a2c;
  color: #fff;
}

.btn-facebook {
  background-color: #1877f2;
  color: #fff;
}
</style>